import { withIconWrapper } from '@/hocs/withIconWrapper';

import ReactComponent from './IconFolder.c.svg?react';

export const IconFolder = withIconWrapper(ReactComponent);
